import { Grid, Typography, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { CRMCarousel, LoginBackgroundCarousel } from '../../assets/images';
import { bajajPrimaryBlue, gray } from '../../theme/palette';
import { MuiStack } from './stackComponent';
var AutoPlaySwipeableViews = autoPlay(SwipeableViews);
var useStyles = makeStyles({
    dot: {
        backgroundColor: gray,
        borderRadius: '50%',
        width: '12px',
        height: '12px',
        margin: '0 5px',
        opacity: 0.5,
        '&.active': {
            opacity: 2,
            backgroundColor: bajajPrimaryBlue,
            boxShadow: "0px 0px 0px 4px rgba(54, 151, 255, 0.24), 0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
        }
    }
});
var sliderContaint = [{
        image: CRMCarousel,
        text: "A robust Vehicle module in a DMS can help dealerships keep track of their inventory, manage sales, and ensure that their vehicles are properly maintained, leading to increased efficiency and profitability.",
        heading: "Vehicle Management"
    }, {
        image: CRMCarousel,
        text: 'A spares management solution is a software system that efficiently organises and oversees spare parts and inventory within the automotive sector.',
        heading: "Spare Management"
    }, {
        image: CRMCarousel,
        text: "A service module in a Dealer Management System (DMS) handles tasks like appointment scheduling, repair orders, inventory management, and reports. It streamlines service operations, improves customer experience, and ensures efficient resource management.",
        heading: "Service Management"
    }, {
        image: CRMCarousel,
        text: "The Finance Management Module in a Dealer Management System (DMS) automates financial processes within a dealership, ensuring smooth transactions and regulatory compliance. It enhances customer service, boosts efficiency, and provides insights to optimize financial performance, crucial for dealership profitability.",
        heading: "Finance Module"
    }, {
        image: CRMCarousel,
        text: "A tailored CRM for automotive dealerships revolutionizes customer experiences and sales through efficient lead management, automated processes, and personalized interactions, ultimately enhancing performance and satisfaction.",
        heading: "CRM"
    }];
var CustomPagination = function (_ref) {
    var count = _ref.count, page = _ref.page, onChange = _ref.onChange;
    var classes = useStyles();
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            display: 'flex',
            bottom: 50,
            position: 'absolute'
        }
    }, Array.from({
        length: count
    }).map(function (_, index) { /*#__PURE__*/ return React.createElement("span", {
        key: index,
        className: "".concat(classes.dot, " ").concat(index === page ? 'active' : ''),
        style: {
            cursor: 'pointer'
        },
        onClick: function (event) { return onChange(event, index); }
    }); }));
};
var AutoSwipeableViews = function () {
    var classes = useStyles();
    var theme = useTheme();
    var _a = useState(0), index = _a[0], setIndex = _a[1];
    var handleChangeIndex = function (index) {
        setIndex(index);
    };
    var handlePaginationChange = function (event, value) {
        setIndex(value);
    };
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'relative',
            width: '100%',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundImage: "url(".concat(LoginBackgroundCarousel, ")"),
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%'
        }
    }, /*#__PURE__*/ React.createElement(AutoPlaySwipeableViews, {
        index: index,
        onChangeIndex: handleChangeIndex,
        interval: 3000,
        resistance: true,
        animateHeight: true,
        style: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: "100%"
        }
    }, sliderContaint.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            key: index,
            justifyContent: "center",
            alignItems: "center",
            height: "100vh"
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 7,
            lg: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: 2
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            direction: "column",
            height: "100%"
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontSize: 30,
            fontWeight: "strong",
            color: "primary.main"
        }, item.heading), /*#__PURE__*/ React.createElement(Typography, {
            fontSize: "lg",
            align: "left",
            mb: 2,
            mt: 1
        }, item.text), /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: "center",
            alignItems: "center"
        }, /*#__PURE__*/ React.createElement("img", {
            src: item.image,
            style: {
                width: 'auto',
                height: 'auto',
                maxWidth: '100%',
                maxHeight: '50vh'
            },
            loading: "lazy"
        })))));
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            display: 'flex',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ React.createElement(CustomPagination, {
        count: sliderContaint === null || sliderContaint === void 0 ? void 0 : sliderContaint.length,
        page: index,
        onChange: handlePaginationChange
    })));
};
export default AutoSwipeableViews;
